import React from "react";
import { PagePlaceholder } from "@/components/common/PagePlaceholder";
import { useStore } from "@/context/StoreContext";
import { formatINR, CURRENCIES } from "@/lib/format";

export function WalletPage() {
  return (
    <PagePlaceholder
      title="My Wallet"
      description="Wallet balance, referral rewards and transaction history activate with the wallet & settlement module in a later phase."
    />
  );
}

export function CurrencyExchange() {
  const { currency } = useStore();
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <span className="eyebrow">Foundation Module</span>
      <h1 className="mt-2 text-3xl font-serif font-bold text-stone-900">Currency Exchange</h1>
      <p className="mt-3 text-stone-600">
        All prices are currently stored and shown in <b>INR (₹)</b>. A live multi-currency conversion service will be
        integrated as a separate future module — we do not display fake exchange rates.
      </p>
      <p className="mt-2 text-sm text-stone-500">Selected display currency: <b>{currency}</b></p>
      <div className="mt-6 rounded-xl border border-border bg-card p-5">
        <h3 className="font-semibold text-stone-900 mb-3">Supported currencies (display foundation)</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {CURRENCIES.map((c) => (
            <div key={c.code} className="flex items-center gap-2 rounded-lg bg-muted px-3 py-2 text-sm">
              <span className="font-bold text-secondary w-8">{c.symbol}</span>
              <span className="text-stone-700">{c.code} — {c.name}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-6 inline-block text-sm text-amber-800 bg-amber-50 border border-amber-100 rounded-xl px-4 py-3">
        Live exchange rates and automatic conversion will be activated in a later development phase.
      </div>
    </div>
  );
}
